import React from 'react';
import { Control, FieldValues, Path } from 'react-hook-form';
import StyledInput from './StyledInput';

type MarginRateStyledInputProps<FieldsType extends FieldValues> = Omit<
  React.ComponentProps<typeof StyledInput<FieldsType>>,
  'type' | 'inputMode'
> & {
  name: Path<FieldsType>;
  control: Control<FieldsType>;
};

const MarginRateStyledInput = <FieldsType extends FieldValues>({
  ...props
}: MarginRateStyledInputProps<FieldsType>) => (
  <StyledInput
    {...props}
    type="text"
    inputMode="decimal"
    hideNumberFieldArrows
  />
);

export default MarginRateStyledInput;
